export const account = {
  seo: {
    login: {
      title: '會員登入 | LensBank',
      description: '登入 LensBank 會員中心，查看訂單狀態、管理個人資料、預約器材租借。'
    },
    register: {
      title: '會員註冊 | LensBank',
      description: '註冊 LensBank 會員，享受便利的器材預約服務與專屬優惠。'
    },
    profile: {
      title: '個人資料 | LensBank 會員中心',
      description: '管理您的個人資料、聯絡方式與偏好設定。'
    },
    orders: {
      title: '我的訂單 | LensBank 會員中心',
      description: '查看您的器材租借訂單狀態與歷史記錄。'
    },
    forgotPassword: {
      title: '忘記密碼 | LensBank',
      description: '重設您的 LensBank 帳號密碼。'
    }
  },
  login: {
    title: '會員登入',
    email: '電子郵件',
    password: '密碼',
    rememberMe: '記住我',
    forgotPassword: '忘記密碼？',
    loginButton: '登入',
    loggingIn: '登入中...',
    noAccount: '還沒有帳號？',
    register: '立即註冊',
    emailPlaceholder: '請輸入電子郵件',
    passwordPlaceholder: '請輸入密碼'
  },
  register: {
    title: '會員註冊',
    name: '姓名',
    email: '電子郵件',
    phone: '電話',
    password: '密碼',
    confirmPassword: '確認密碼',
    company: '公司名稱（選填）',
    vatNumber: '統一編號（選填）',
    registerButton: '註冊',
    registering: '註冊中...',
    hasAccount: '已有帳號？',
    login: '立即登入',
    agree: '我同意',
    terms: '服務條款',
    and: '與',
    privacy: '隱私政策',
    success: {
      title: '註冊成功！',
      message: '我們已發送驗證信至您的電子郵件',
      checkEmail: '請查收信箱並點擊驗證連結以啟用帳號',
      backToLogin: '返回登入頁面'
    }
  },
  forgotPassword: {
    title: '忘記密碼',
    description: '請輸入您的電子郵件，我們將發送重設密碼的連結給您',
    email: '電子郵件',
    emailPlaceholder: '請輸入電子郵件',
    sendButton: '發送重設連結',
    sending: '發送中...',
    backToLogin: '返回登入',
    success: {
      title: '重設信件已送出！',
      message: '若此 Email 已註冊，我們會寄出密碼重設連結。請檢查收件匣與垃圾郵件。',
      checkEmail: '連結有效時間為 1 小時，請盡早操作',
      backToLogin: '返回登入頁面'
    }
  },
  resetPassword: {
    title: '重設密碼',
    description: '請輸入新密碼並再次確認',
    newPassword: '新密碼',
    confirmPassword: '確認新密碼',
    submitButton: '確認重設密碼',
    submitting: '重設中...',
    successTitle: '密碼已重設！',
    successMessage: '您的密碼已成功更新，請使用新密碼登入。',
    backToLogin: '返回登入頁面',
    invalidOrExpired: '重設連結已無效或已過期，請重新申請密碼重設。',
    errorTitle: '無法重設密碼',
    errorMessage: '驗證連結無效或已過期。'
  },
  errors: {
    invalidEmail: '請輸入有效的電子郵件格式',
    emailRequired: '請輸入電子郵件',
    passwordRequired: '請輸入密碼',
    passwordTooShort: '密碼至少需要 8 個字元',
    passwordMismatch: '兩次輸入的密碼不一致',
    nameRequired: '請輸入姓名',
    phoneRequired: '請輸入電話',
    invalidCredentials: '電子郵件或密碼錯誤',
    emailAlreadyExists: '此電子郵件已被註冊',
    userNotFound: '找不到此帳號',
    networkError: '網路連線錯誤，請稍後再試',
    unknownError: '發生未知錯誤，請稍後再試',
    agreeTerms: '請同意服務條款與隱私政策'
  },
  profile: {
    title: '個人資料',
    subtitle: '管理您的個人資訊與帳號設定',
    basicInfo: '基本資訊',
    name: '姓名',
    email: '電子郵件',
    emailReadonly: '電子郵件無法變更',
    phone: '電話',
    company: '公司名稱',
    vatNumber: '統一編號',
    preferredLocation: '常用門市',
    selectLocation: '選擇門市',
    changePassword: '變更密碼',
    currentPassword: '目前密碼',
    newPassword: '新密碼',
    confirmPassword: '確認新密碼',
    save: '儲存變更',
    saving: '儲存中...',
    cancel: '取消',
    edit: '編輯資料',
    security: '帳號安全',
    password: '密碼',
    change: '變更',
    changePasswordNote: '如需變更密碼，請前往「忘記密碼」頁面進行重設',
    updateSuccess: '個人資料已成功更新',
    updateError: '更新失敗，請稍後再試',
    adminAccountNotice: '此帳號為最高權限管理帳號，基於安全原則不可作為前台租賃帳號。請使用一般客戶帳號測試或下單。',
    staffAccountNotice: '您目前是 LensBank 員工帳號。若要使用前台租賃功能，請先建立個人租賃資料。此資料僅用於前台租賃，不會影響您的後台權限。',
    staffAccountReady: '您目前是 LensBank 員工帳號，前台租賃資料已建立。您可以正常使用前台租賃功能，後台權限不受影響。',
    createRentalProfile: '編輯並建立前台租賃資料'
  },
  orders: {
    title: '我的訂單',
    subtitle: '查看和管理您的器材租借訂單',
    orderNumber: '訂單編號',
    date: '訂單日期',
    status: '狀態',
    total: '總金額',
    action: '操作',
    viewDetails: '查看詳情',
    noOrders: '目前沒有訂單',
    
    // 新增：狀態標籤
    allOrders: '全部訂單',
    pending: '待審核',
    approved: '已確認',
    completed: '已完成',
    
    // 新增：狀態顯示文字
    statusPending: '待審核',
    statusApproved: '已確認',
    statusNeedInfo: '需補資料',
    statusCompleted: '已完成',
    statusCancelled: '已取消',
    
    // 新增：訂單詳情頁面
    backToOrders: '返回訂單列表',
    orderDetails: '訂單詳情',
    rentalPeriod: '租借期間',
    pickupLocation: '取件門市',
    equipmentList: '器材清單',
    quantity: '數量',
    days: '天',
    totalPrice: '總金額',
    customerNotes: '客戶備註',
    adminNotes: '管理員備註',
    startBrowsing: '開始瀏覽器材',
    
    statuses: {
      draft: '草稿',
      pending: '待審核',
      need_info: '需補資料',
      approved: '已確認',
      rejected: '已拒絕',
      completed: '已完成',
      cancelled: '已取消'
    },
    detail: {
      title: '訂單詳情',
      orderInfo: '訂單資訊',
      orderNumber: '訂單編號',
      orderDate: '訂單日期',
      status: '狀態',
      rentalInfo: '租借資訊',
      pickupDate: '取件日期',
      returnDate: '還件日期',
      rentalDays: '租借天數',
      locations: '取還件門市',
      pickupLocation: '取件門市',
      returnLocation: '還件門市',
      rentalPeriod: '租借期間',
      items: '訂單品項',
      equipment: '器材',
      quantity: '數量',
      price: '金額',
      subtotal: '小計',
      total: '總計',
      notes: '備註',
      adminNotes: '管理員備註',
      cancel: '取消訂單',
      back: '返回列表'
    }
  },
  nav: {
    profile: '個人資料',
    orders: '我的訂單',
    cart: '預約車',
    logout: '登出'
  },

  // 新增：購物車相關翻譯
  cart: {
    title: '預約車',
    subtitle: '確認您的器材預約清單',
    empty: '預約車是空的',
    emptyDescription: '開始瀏覽器材並加入預約車',
    startBrowsing: '開始瀏覽器材',
    days: '天',
    quantity: '數量',
    remove: '移除',
    removeConfirm: '確定要移除此項目嗎？',
    removeSuccess: '已從預約車移除',
    summary: '訂單摘要',
    subtotal: '租金小計',
    deposit: '押金',
    total: '總計',
    depositNote: '押金將於歸還器材後退還',
    proceedToCheckout: '前往結帳',
    continueBooking: '繼續預約',
    loginRequired: '請先登入會員才能結帳'
  },

  // 新增：結帳相關翻譯
  checkout: {
    title: '結帳',
    subtitle: '填寫租借資訊並完成預約',
    loginRequired: '請先登入會員才能進行結帳',
    rentalInfo: '租借資訊',
    startDate: '取件日期',
    endDate: '還件日期',
    pickupLocation: '取件門市',
    selectLocation: '請選擇取件門市',
    rentalDays: '天數',
    days: '天',
    equipmentList: '器材清單',
    quantity: '數量',
    projectInfo: '拍攝資訊',
    projectType: '專案類型',
    projectTypePlaceholder: '例如：商業攝影、婚禮紀錄、影片拍攝等',
    shootingLocation: '拍攝地點',
    shootingLocationPlaceholder: '例如：台北市信義區、戶外拍攝等',
    specialRequirements: '特殊需求',
    specialRequirementsPlaceholder: '請告訴我們您的特殊需求或注意事項',
    orderSummary: '訂單摘要',
    equipmentSubtotal: '單價合計',
    subtotal: '小計',
    discount: '折扣',
    rentalTotal: '租金總計',
    deposit: '押金',
    total: '總計',
    depositNote: '押金將於歸還器材後退還',
    submitOrder: '確認送出訂單',
    submitting: '送出中...',
    backToCart: '返回購物車',
    agreeTerms: '我已閱讀並同意',
    rentalTerms: '租借條款',
    fillRequired: '請填寫所有必填欄位',
    agreeTermsRequired: '請同意租借條款',
    success: {
      title: '預約完成！',
      message: '感謝您的預約',
      description: '我們已收到您的預約資訊，將盡快與您聯繫確認',
      orderNumber: '訂單編號',
      viewOrders: '查看訂單',
      backToHome: '返回首頁'
    },
    successModal: {
      title: '訂單已送出',
      message: '訂單已經送出，但不表示下訂已完成。\n可接單狀況待取件店面確認完庫存後，會以 LINE 或 Email 通知您。\n您也可以至「我的訂單」查看最新狀態。',
      viewOrdersButton: '查看我的訂單',
      continueBrowsingButton: '繼續瀏覽器材'
    },
    adminAccountBlocked: '此帳號為最高權限管理帳號，基於安全原則不可作為前台租賃帳號下單。請使用一般客戶帳號測試或下單。',
    staffNeedProfile: '請先建立前台租賃資料後再送出訂單。'
  },

  // Email 確認相關
  confirmingEmail: '正在確認您的電子郵件...',
  pleaseWait: '請稍候',
  confirmSuccess: '確認成功！',
  emailConfirmed: '您的電子郵件已成功確認，歡迎加入！',
  confirmFailed: '確認失敗',
  emailConfirmError: '確認連結無效或已過期，請重新註冊',
  redirectingToHome: '即將跳轉到首頁...',
  backToLogin: '返回登入頁面',
};